/* eslint-disable no-console */
import PageViewTracking from 'components/shared/PageViewTracking';
import useNProgress from 'hooks/useNProgress';
import { getClientLanguage } from 'locale';
import Link from 'next/link';
import PusherProvider from 'providers/PusherProvider';
import QueryProvider from 'providers/QueryProvider';
import React from 'react';
import PropTypes from 'prop-types';
import ThemeProvider from '@seaweb/coral/components/ThemeProvider';
import Footer from 'components/shared/Footer';
import NavBar from 'components/shared/NavBar';
import LocaleProvider from 'providers/LocaleProvider';
import NavInfoProvider from 'providers/NavInfoProvider';
import SearchProvider from 'providers/SearchProvider';
import ViewContextProvider from 'providers/ViewContextProvider';
import 'react-quill/dist/quill.snow.css';
import 'styles/global.css';
import serverFetchLogs from 'utils/serverFetchLog';
import smoothScroll from 'smoothscroll-polyfill';
import MaintenanceBanner from 'components/shared/MaintenanceBanner';

// Polyfill smooth scroll behavior for safari
if (typeof window !== `undefined`) {
  smoothScroll.polyfill();
}

Link.defaultProps = {
  ...Link.defaultProps,
  passHref: true,
};

const fontFamily =
  "OpenSans, 'Helvetica Neue', Helvetica, Arial, 'PingFang SC', 'Hiragino Sans GB', 'Heiti SC', 'Microsoft YaHei UI', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;";

const coralTheme = {
  typography: { main: fontFamily },
  spacing: { radius: 2 },
};

function App({
  Component,
  pageProps,
  serverLanguage,
  serverUserAgent,
  serverHost,
  serverFetchLogs: logs,
}) {
  const language =
    typeof window !== 'undefined' ? getClientLanguage() : serverLanguage;
  const host =
    typeof window !== 'undefined' ? window.location.host : serverHost;

  useNProgress();

  if (process.env.ENV === 'test' && logs) {
    console.log(
      '%c SERVER FETCHES',
      'color:green;font-weight:bold;font-size:12px'
    );
    console.log(logs);
  }

  return (
    <ThemeProvider theme={coralTheme}>
      <QueryProvider>
        <LocaleProvider language={language} host={host}>
          <PusherProvider>
            <ViewContextProvider serverUserAgent={serverUserAgent}>
              <NavInfoProvider>
                <MaintenanceBanner />
                <SearchProvider>
                  <PageViewTracking>
                    <NavBar />
                    <div className="app-wrapper">
                      <Component {...pageProps} />
                    </div>
                    <Footer />
                    <div className="sz-deploy-help-center" />
                  </PageViewTracking>
                </SearchProvider>
              </NavInfoProvider>
            </ViewContextProvider>
          </PusherProvider>
        </LocaleProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}

App.propTypes = {
  Component: PropTypes.any,
  pageProps: PropTypes.any,
  serverLanguage: PropTypes.string,
  serverUserAgent: PropTypes.string,
  serverFetchLogs: PropTypes.array,
  serverHost: PropTypes.string,
};

App.getInitialProps = async ({ ctx }) => {
  const { req } = ctx || {};
  const { cookies } = req || {};
  const { fetch_log: fetchLog } = cookies || {};

  if (fetchLog === 'true') {
    serverFetchLogs.clear();
    return { serverFetchLogs: serverFetchLogs.get() };
  }

  return {};
};

export default App;
